import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_picking_discrepancy_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    qty_picked: fromDatatype.NumericDatatypeInterface;
    discrepancy: fromDatatype.NumericDatatypeInterface;
    required_qty: fromDatatype.NumericDatatypeInterface;
    picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    picking_cart_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_wms_picking_discrepancy_RowClass
    implements bl_wms_picking_discrepancy_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        qty_picked: fromDatatype.NumericDatatypeInterface;
        discrepancy: fromDatatype.NumericDatatypeInterface;
        required_qty: fromDatatype.NumericDatatypeInterface;
        picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
        picking_cart_guid: fromDatatype.GuidDataFieldInterface;
        property_json: fromDatatype.JsonDatatypeInterface;
        namespace: fromDatatype.VarcharDatatypeInterface;
        acl_config: fromDatatype.JsonDatatypeInterface;
        acl_policy: fromDatatype.JsonDatatypeInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        status: fromDatatype.StatusDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;
}